import axios from "axios";
import { message } from "antd";

// Store baseURL from environment
const baseURL = process.env.REACT_APP_BASE_URL;

// Keep track of current slug to fetch the correct token
let currentSlug = null;

export const setApiSlug = (slug) => {
  currentSlug = slug;
};

const drEasyApi = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 10000,
});

// Request interceptor to set token and language
drEasyApi.interceptors.request.use(
  (config) => {
    // Dynamically import i18n to get current language
    const i18n = require("../i18n").default;
    config.headers["Accept-Language"] = i18n.language;
    
    if (currentSlug) {
      const token =
        localStorage.getItem(`userTkn-${currentSlug}`) ||
        sessionStorage.getItem(`userTkn-${currentSlug}`);
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor (keep as is)
drEasyApi.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response, request, code } = error;

    if (!response) {
      if (code === 'ECONNABORTED') {
        message.error("Request timeout. Please check your connection and try again.");
      } else if (code === 'ERR_NETWORK') {
        message.error("Network error. Please check your internet connection.");
      } else if (request) {
        message.error("Unable to connect to server. Please try again later.");
      } else {
        message.error("An unexpected error occurred. Please try again.");
      }
      return Promise.reject(error);
    }
    
    return Promise.reject(error);
  }
);

export default drEasyApi;